<template>
  <div class="admin-equipment-container">
    <el-row :gutter="10">
      <el-col :span="4" class="pr-0">
        <community-machine-type-tree ref="machineTypeTree" @selectMachineType="handleSelectMachineType" />
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminEquipment.search.title') }} : {{rep}}</span>
          </div>
          <div class="search-content">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-input v-model.trim="searchForm.detailId" :placeholder="$t('adminEquipment.search.detailId')"
                  clearable />
              </el-col>
              <el-col :span="4">
                <el-input v-model.trim="searchForm.bId" :placeholder="$t('adminEquipment.search.bId')" clearable />
              </el-col>
              <el-col :span="4">
                <el-select v-model="searchForm.detailType" :placeholder="$t('adminEquipment.search.detailType')"
                  clearable>
                  <el-option v-for="item in useStatus" :key="item.detailType" :label="item.name"
                    :value="item.detailType" />
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="handleSearch">
                  {{ $t('common.search') }}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="box-card mt-10">
          <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="detailId" :label="$t('adminEquipment.table.detailId')" align="center" />
            <el-table-column prop="bId" :label="$t('adminEquipment.table.bId')" align="center" />
            <el-table-column prop="amount" :label="$t('adminEquipment.table.amount')" align="center" />
            <el-table-column prop="detailType" :label="$t('adminEquipment.table.detailType')" align="center">
              <template slot-scope="scope">
                {{ formatDetailType(scope.row.detailType) }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="orderId" :label="$t('adminEquipment.table.orderId')" align="center" /> -->
            <el-table-column prop="remark" :label="$t('adminEquipment.table.remark')" align="center" />
            <el-table-column prop="createTime" :label="$t('adminEquipment.table.createTime')" align="center" />
          </el-table>

          <el-row class="mt-10">
            <!-- <el-col :span="12" class="text-left">
              <div>{{ $t('adminEquipment.statusTip') }}</div>
            </el-col> -->
            <el-col :span="12" class="text-right">
              <el-pagination :current-page.sync="pagination.current" :page-sizes="[10, 20, 30, 50]"
                :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import { listAdminEquipmentAccount } from '@/api/resource/adminEquipmentApi'
import { queryTePdaccountDetail } from '@/api/account/accountDetailManageApi'
import CommunityMachineTypeTree from '@/components/resource/CommunityMachineTypeTree'
// import {getDict} from '@/api/community/communityApi'

export default {
  name: 'TemporaryPropertyDeposit',
  components: {
    CommunityMachineTypeTree
  },
  data() {
    return {
      loading: false,
      searchForm: {
        detailId: '',
        bId: '',
        communityId: '',
        detailType: '',
        importanceLevel: '',
        typeId: ''
      },
      tableData: [],
      useStatus: [{ detailType: '', name: '全部' },      // 全部选项，值为空字符串
      { detailType: '1001', name: '转入' },  // 转入选项，值为1001
      { detailType: '2002', name: '转出' },  // 转出选项，值为2002
      { detailType: '4004', name: '退款' }  // 退款选项，值为3003
      ],
      importanceLevels: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      rep: 0
    }
  },
  created() {
    // this.getDictData()
    this.getList()
    this.$refs.machineTypeTree.ini
  },
  methods: {
    // async getDictData() {
    // try {
    //   const detailTypeData = await getDict('equipment_account','detailType')
    //   this.useStatus = detailTypeData

    //   const levelData = await getDict('equipment_account','importance_level')
    //   this.importanceLevels = levelData
    // } catch (error) {
    //   console.error('Failed to load dictionary data:', error)
    // }
    // },
    async getList() {
      try {
        this.loading = true
        const params = {
          ...this.searchForm,
          page: this.pagination.current,
          row: this.pagination.size
        }
        const { data, total, rep} = await queryTePdaccountDetail(params)
        this.tableData = data
        this.pagination.total = total
        this.rep =rep.totalAmount
      } catch (error) {
        this.$message.error(this.$t('adminEquipment.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSelectMachineType(data) {
      this.searchForm.typeId = data.typeId
      this.searchForm.communityId = data.communityId
      this.handleSearch()
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    // 格式化 detailType 值为中文显示
  formatDetailType(value) {
    if (value === '1001') {
      return '转入';
    } else if (value === '2002') {
      return '转出';
    } else if (value === '4004') {
      return '退款';
    } else {
      return value; // 如果有其他值则直接返回原值
    }
  },
  }
}
</script>

<style lang="scss" scoped>
.admin-equipment-container {
  padding: 20px;

  .pr-0 {
    padding-right: 0;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .text-right {
    text-align: right;
  }

  .search-content {
    padding: 20px 0;
  }
}
</style>